import { type SessionsAsset, useGetWorkspacesQuery } from '@carboncopyco/data';
import { useDashboardProps } from '../DashboardContext';

export const useAssetStatus = () => {
  const { organizationId } = useDashboardProps();
  const { data: workspaces } = useGetWorkspacesQuery({
    organizationId,
  });

  return (asset: SessionsAsset) =>
    workspaces?.some((workspace) => String(workspace.id) === asset.workspaceId);
};
